import { createStorybookSvgIcon as o } from "../../utils/create-svg-icons-sb.js";
import { createSvgIcon as r } from "../../utils/create-svg-icons.js";
const c = process.env.HORIZON_FETCH_SVGS === "true" ? o : r;
export {
  c as svgCreate
};
